"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonErrors_en_us = void 0;
function commonErrors_en_us() {
    return {
        "errors.notfound": "Not found",
        "errors.nodata": "No data available",
        "errors.generic": "An unexpected error occurred",
        "errors.tryagainlater": "An error occurred, please try again later.",
        "errors.invalidmail": "Please enter a valid e-mail address (e.g. test@gmail.com)",
        "errors.invalidphonenumber": "Please enter a valid phone number (e.g. +49896121247)",
        "errors.invalidurl": "Please enter a valid URL",
        "errors.http.400": "The request was invalid",
        "errors.http.401": "You are not logged in",
        "errors.http.403": "Sorry, you don't have access to this resource",
        "errors.http.404": "Sorry, the requested resource does not exist",
        "errors.http.409": "The resource exists already",
        "errors.http.500": "Something went wrong",
        "errors.http.503": "The service is not available at this moment",
        "errors.unreachable.title": "Error",
        "errors.unreachable.message": "The system is currently unavailable, please try again in a few moments!",
        "errors.access.nottheowner": "You're not the owner of this resource",
        "errors.validations.validating_field": "Input",
        "errors.validations.validation_failed_message": "Errors occured while validating your input!",
        "errors.validations.required": "required",
        "errors.validations.isalpha": "must contain only lowercase letters (a-z)",
        "errors.validations.isemail": "must be a valid E-Mail",
        "errors.validations.islowercase": "all letters must be lowercase",
        "errors.validations.isurlconform": "Maximum of 45 letters. All letters must be Url conform (a-Z 0-9 _\\-~)",
        "errors.validations.length": "must have a min length of 3 letters",
        "errors.validations.minlength": "must have a minimum length of ${requiredLength} characters",
        "errors.validations.maxlength": "can't be longer than ${maxLength} characters",
        "errors.validations.min": "must have a minimum of ${min}",
        "errors.validations.max": "can't be bigger than ${max}",
        "errors.validations.minitems": "provide at least ${min} elements",
        "errors.validations.maxitems": "provide at most ${max} elements",
        "errors.validations.isstring": "must be a string",
        "errors.validations.isint": "must be a number",
        "errors.validations.isobject": "must be a JavaScript object",
        "errors.validations.isjsonschema7": "must be a valid JSONSchema7",
        "errors.validations.matches": "must match the pattern",
        "errors.validations.isdefined": "must be defined",
        "errors.validations.pattern": "must follow this pattern: ${requiredPattern}",
        "errors.validations.iconerror": "must be a valid icon",
        "errors.validations.invalidvalue": "must be one of the proposed values",
        "errors.validations.enum": "must be one of these: ${enumValues}",
        "errors.validations.type": "type must be ${type}",
        "errors.user.email_already_exists": "This E-Mail is already registered",
        "errors.user.invalid_password_uppercasemissing": "Invalid Password: Uppercase character is missing",
        "errors.user.invalid_password_lowercasemissing": "Invalid Password: Lowercase character is missing",
        "errors.user.invalid_password_notatleast8characterslong": "Invalid Password: Please provide at least 8 characters",
        "errors.user.invalid_password_nospecialcharacter": "Invalid Password: Please provide a special character like ! ? # or spaces",
        "errors.user.token_required": "No token received",
        "errors.user.invalid_password": "Invalid Password",
        "errors.user.user_not_found": "User not found",
        "errors.user.invalid_token": "Invalid Token",
        "errors.user.invalidjsonprofileschema": "User profile schema is formatted as valid JSON",
        "errors.user.notmatchingprofileschema": "User profile does not match the defined schema",
        "errors.user.noprofileschema": "No current JSON formatted user profile schema found",
        "errors.user.notalloldkeyspresentinschema": "Not all keys of previous schema are present in schema update",
        "errors.user.newandoldtypenotmatching": "All types in the new schema must match the previous types",
        "errors.user.creationnotallowed": "Creation of new users is not allowed.",
        "errors.invitation.missingrole": "An invitation should contain at least one role",
        "errors.invitation.notenant": "No tenant found for id: ",
        "errors.invitation.notinvitable": "Invites can only be created for projects or companies.",
        "errors.verify.email.invalid_token": "Token not valid",
        "errors.verify.email.incorrect_token": "Token is incorrect",
        "errors.verify.email.email_not_found": "Email could not be found",
        "errors.verify.email.could_not_send": "Email confirmation could not be sent",
        "errors.file.unsplash.notoken": "Reseller has set no API Key for Unsplash.com.",
        "errors.file.unsplash.invalidtoken": "Token for Unsplash.com is invalid.",
        "errors.file.unsplash.limitexceeded": "Requestlimit of Unsplash.com has been exceeded.",
        "errors.file.unsplash.generalerror": "The request to Unsplash.com has resulted in an error.",
        "errors.note.noservicetoken": "ServiceTokens cannot be uses to access or edit notes.",
        "errors.note.usernotfound": "No user could be found for this note.",
        "errors.note.onlyeditpersonal": "Only personal notes can be edited.",
        "errors.note.onlyaccesspersonal": "Personal notes of others cannot be accessed.",
        "errors.note.notargetidchange": "The targetId cannot be changed or deleted."
    };
}
exports.commonErrors_en_us = commonErrors_en_us;
